var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { PopupButton } from '@typeform/embed-react';
export function Typeform(_a) {
    var typeformId = _a.typeformId, className = _a.className, children = _a.children;
    var _b = useState(false), isReady = _b[0], setIsReady = _b[1];
    var _c = useState(0), screenHeight = _c[0], setScreenHeight = _c[1];
    var autoCloseInMs = 5 * 1000;
    useEffect(function () {
        setIsReady(true);
        setScreenHeight(window.innerHeight);
    }, []);
    // See options: https://www.typeform.com/developers/embed/configuration/#available-options
    return (_jsx(PopupButton, __assign({ id: typeformId, iframeProps: {
            id: 'typeform-iframe',
            style: "max-height:".concat(screenHeight, "px"),
        }, className: className, redirectTarget: "_blank", autoClose: autoCloseInMs, as: 'span', transitiveSearchParams: true }, { children: isReady && children })));
}
